/**
 * Кастомная иконка «Лист/Документ» (filled)
 *
 * Документ с загнутым уголком и строками текста
 * fill="currentColor" для окрашивания через Tailwind
 * Совместима с IconComponent (принимает size, style, className)
 */

import type { CSSProperties } from 'react';

interface IconProps {
  className?: string;
  size?: number | string;
  style?: CSSProperties;
}

export function PaperIcon({ className, size, style }: IconProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M13.3261 2C13.5987 2 13.8084 2.21 13.8084 2.46V5.68C13.8084 7.51 15.3914 9.01 17.3098 9.02C18.1066 9.02 18.7356 9.03 19.2178 9.03L19.3964 9.02926C19.7187 9.02694 20.1526 9.02 20.5282 9.02C20.7903 9.02 21 9.22 21 9.47V17.51C21 19.99 18.8928 22 16.293 22H7.94817C5.22248 22 3 19.89 3 17.29V6.51C3 4.03 5.11765 2 7.72801 2H13.3261ZM14.4479 14.9H8.7449C8.31508 14.9 7.95865 15.23 7.95865 15.64C7.95865 16.05 8.31508 16.39 8.7449 16.39H14.4479C14.8777 16.39 15.2341 16.05 15.2341 15.64C15.2341 15.23 14.8777 14.9 14.4479 14.9ZM12.2883 9.9H8.7449C8.31508 9.9 7.95865 10.24 7.95865 10.65C7.95865 11.06 8.31508 11.39 8.7449 11.39H12.2883C12.7181 11.39 13.0745 11.06 13.0745 10.65C13.0745 10.24 12.7181 9.9 12.2883 9.9ZM15.336 2.906C15.336 2.475 15.8843 2.261 16.1978 2.572C17.331 3.696 19.3113 5.661 20.4184 6.759C20.7245 7.062 20.5002 7.565 20.0588 7.566C19.1971 7.569 18.1812 7.566 17.4505 7.559C16.2911 7.559 15.336 6.648 15.336 5.542V2.906Z"
        fill="currentColor"
      />
    </svg>
  );
}